import React from "react";
import PropTypes from "prop-types";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import FusionGdbDiseaseAssociationsContent from "./FusionGdbDiseaseAssociationsContent";
import FusionGdbGenesContent from "./FusionGdbGenesContent";
import FusionGdbDrugsContent from "./FusionGdbDrugsContent";
import HelperText from "../../../../components/atoms/HelperText";

const FusionGdb = ({ data }) => {
  if (!data || Object.keys(data || {}).length === 0) return null;

  return (
    <div className="varsome-result-fixed" data-testid="fusion-gdb-component">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title="Fusion GDB"
          version={data?.version}
          url={getVarsoUrl("https://compbio.uth.edu/FusionGDB2/")}
          heperPopup={<HelperText fieldDescriptionKey="Fusion GDB" />}
          content={
            <div className="varsome-inner-container">
              {data?.fusion_genes && (
                <FusionGdbGenesContent genesList={data?.fusion_genes} />
              )}
              {data?.related_drugs && (
                <FusionGdbDrugsContent drugsList={data?.related_drugs} />
              )}
              {data?.disease_associations && (
                <FusionGdbDiseaseAssociationsContent
                  diseaseAssociationsList={data?.disease_associations}
                />
              )}
            </div>
          }
        />
      </div>
    </div>
  );
};

FusionGdb.propTypes = {
  data: PropTypes.shape({
    disease_associations: PropTypes.arrayOf(
      PropTypes.shape({
        disease_name: PropTypes.string,
        disgenet_id: PropTypes.string,
        source: PropTypes.arrayOf(PropTypes.string),
      })
    ),
    fusion_genes: PropTypes.arrayOf(
      PropTypes.shape({
        fusion_symbol: PropTypes.string,
        to_gene_symbol: PropTypes.string,
        from_gene_symbol: PropTypes.string,
      })
    ),
    related_drugs: PropTypes.arrayOf(
      PropTypes.shape({
        action: PropTypes.string,
        drug_bank_id: PropTypes.string,
        drug_name: PropTypes.string,
        drug_status: PropTypes.arrayOf(PropTypes.string),
        drug_type: PropTypes.string,
        uniprot_accession_id: PropTypes.string,
      })
    ),
    version: PropTypes.string,
  }).isRequired,
};

export default withErrorGuard(FusionGdb, "FusionGdb", "Fusion GDB");
